import { loadingActions } from 'modules/loading';
import { CONTRACT } from 'constants/global';
import { contractsActions } from '.';
import ContractsApi from './repository';

export const getContracts = (params = null, options = {}) => async (dispatch) => {
  const silent = Boolean(options?.silent);
  if (!silent) dispatch(loadingActions.show());
  const stopLoading = () => {
    if (!silent) dispatch(loadingActions.hide());
  };

  const onSuccess = (contracts) => {
    const auxContracts = (contracts || []).map((contract) => {
      const isPeriodoAdicional = contract?.DesEstatus?.toLowerCase() === 'periodo adicional';
      return {
        ...contract,
        auxType: CONTRACT,
        auxOrder: new Date(isPeriodoAdicional ? contract.FechaPad : contract.FechaPago).getTime(),
        isAuto: contract?.Numero && Number(contract.Numero[0]) === 8,
      };
    });
    auxContracts.sort((a, b) => a.auxOrder - b.auxOrder);
    if (!params) {
      dispatch(contractsActions.success(auxContracts));
    }
    stopLoading();
    return auxContracts;
  };

  return ContractsApi.getContracts(params)
    .then((contracts) => {
      if (!contracts) {
        dispatch(contractsActions.error('No contracts found'));
        stopLoading();
        return false;
      }
      return onSuccess(contracts);
    })
    .catch((error) => {
      if (['No se encontro información.', 'El cliente no se encuentra registrado.'].includes(error?.data?.error)) {
        return onSuccess([]);
      }
      dispatch(contractsActions.error(error?.message || error));
      stopLoading();
      return false;
    });
};

export const getContract = (contractId) => {
  return ContractsApi.getContract(contractId);
};

export const getPayments = (contractId, status = []) => {
  return ContractsApi.getPayments(contractId, status);
};

export const getReference = (contractId, referenceId) => {
  return ContractsApi.getReference(contractId, referenceId);
};

export const getPackage = (packageId) => {
  return ContractsApi.getPackage(packageId);
};
